import Action from '@/gf/components/Action'
import UploadButton from '@/gf/components/UploadButton'
import Attachment from '@/gf/modules/Attachment'
import { ArrowUpTrayIcon } from '@heroicons/react/20/solid'

export interface QuoteUploadProps {
  onUploadStarted: () => void
  onUploadComplete: (files: { name: string; url: string }[]) => Promise<void>
  onError: (message: string) => void
  rfqId: string | null
}

const QuoteUploadButton = ({
  onError,
  onUploadStarted,
  onUploadComplete,
  rfqId,
}: QuoteUploadProps) => (
  <UploadButton
    allowedFileTypes={Attachment.documentFileTypes}
    onError={onError}
    onUploadComplete={onUploadComplete}
    onUploadStarted={onUploadStarted}
    uploadContext="dealer_quote_upload"
    key={rfqId}
  >
    <Action.S className="whitespace-nowrap">
      <ArrowUpTrayIcon className="-ml-0.5 mr-1.5 w-4 h-4 inline-flex shrink-0 text-gray-700" />
      Upload Quote
    </Action.S>
  </UploadButton>
)

export default QuoteUploadButton
